export default {
  label: {
    scale: '分制',
    chooseScale: '选择分制',
    inheritCompany: '使用父公司设置',
    scaleChineseDescription: '中文分制描述',
    scaleEnglishDescription: '英文分制',
    scorePoint: '{score} 分制',
    point: '{score} 分'
  },
  message: {
    confirmUseParentCompanyConfig: '请确认使用父公司配置',
    confirmCancelParentCompanyConfig: '请确认不使用父公司配置'
  }
}
